import { render, staticRenderFns } from "./CustomerCtField.vue?vue&type=template&id=25515c5c"
import script from "./CustomerCtField.vue?vue&type=script&lang=js"
export * from "./CustomerCtField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports